import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaCircleCheck, FaCheck } from 'react-icons/fa6';

export default function PaymentConfirmationModal({
  show,
  onHide,
  onConfirm,
  canConfirm = true,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      centered
      className="payment-confirm-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0" />
      <Modal.Body className="text-center pt-0 px-4 pb-4">
        <div className="payment-confirm-icon-badge my-3">
          <FaCircleCheck size={34} />
        </div>
        <h4 className="fw-bold text-dark mb-2">Confirmação de Pagamento</h4>
        <div className="bg-light border-0 rounded-3 p-3 my-3">
          <p className="text-secondary mb-0 fs-6 lh-base">
            Já efetuou o pagamento utilizando este código e deseja{' '}
            <strong className="text-success fw-bold">confirmar</strong> em nossa plataforma?
          </p>
        </div>

        <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center pt-2">
          {canConfirm && (
            <Button
              variant="success"
              className="px-4 py-2 fw-medium d-flex align-items-center justify-content-center shadow-sm rounded-3"
              onClick={onConfirm}
            >
              <FaCheck className="me-2" />
              Sim, efetuei e quero confirmar
            </Button>
          )}
          <Button
            variant="outline-secondary"
            className="px-4 py-2 fw-medium rounded-3"
            onClick={onHide}
          >
            Cancelar
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
